import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/buyer/settings/my-account")({
	component: RouteComponent
});

function RouteComponent() {
	return <div>Hello "/buyer/settings/my-account"!</div>;
}
